<template>
  <v-card
    color="#EFF3F8"
    outlined
  >
    <v-container class="text-uppercase">
      <v-row>
        <v-col cols="1">
          <v-checkbox
            @click="handleCheckboxClickConciliacaoLote"
            :value="isSelected"
            color="primary"
            class="ml-1 mt-0"
            readonly
            hide-details
            dense
          />
        </v-col>
        <v-col>
          <div>Cronograma</div>
          <div><b>{{ faturamentoLoteBaixado.faturamentoLote.dataRegistroTransacao | formatDate }}</b></div>
        </v-col>

        <v-col>
          <div>Nº lote</div>
          <div><b>{{ faturamentoLoteBaixado.faturamentoLote.numeroLote }}</b></div>
        </v-col>

        <v-col>
          <div>Total</div>
          <div><b>{{ faturamentoLoteBaixado.faturamentoLote.valorTotal | formatCurrency }}</b></div>
        </v-col>

        <v-col>
          <div>Qtde. guias</div>
          <div><b>{{ faturamentoLoteBaixado.faturamentoLote.quantidadeGuias }}</b></div>
        </v-col>

        <v-col>
          <div>Pago</div>
          <div class="success--text"><b>{{ faturamentoLoteBaixado.faturamentoLote.valorPagoConciliacaoItens | formatCurrency }}</b></div>
        </v-col>

        <v-col>
          <div>Glosado</div>
          <div class="red--text"><b>{{ faturamentoLoteBaixado.faturamentoLote.valorGlosadoConciliacaoItens | formatCurrency }}</b></div>
        </v-col>

      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { formatCurrency } from '../../../libs'

export default {
  props: {
    isAssociado: Boolean,
    isSelected: Boolean,
    faturamentoLoteBaixado: Object
  },
  methods: {
    handleCheckboxClickConciliacaoLote () {
      this.$emit('click:checkbox', this.faturamentoLoteBaixado, this.isSelected)
    }
  },
  filters: {
    formatCurrency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
